var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    fill: "none",
    viewBox: "0 0 30 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.057 27H5.952a3.9 3.9 0 0 1-2.793-1.186A4.1 4.1 0 0 1 2 22.954v-11.28a4.1 4.1 0 0 1 .48-1.94A4 4 0 0 1 3.81 8.27l8.553-5.628A3.9 3.9 0 0 1 14.5 2c.758 0 1.5.222 2.137.64l8.553 5.628c.556.366 1.014.87 1.33 1.465s.482 1.262.48 1.94v11.28a4.1 4.1 0 0 1-1.156 2.856A3.9 3.9 0 0 1 23.057 27M14.505 3.706c-.44 0-.87.128-1.239.37l-8.549 5.63a2.3 2.3 0 0 0-.77.846c-.183.344-.279.73-.278 1.122v11.28c0 .62.241 1.216.67 1.655a2.26 2.26 0 0 0 1.617.686h17.101a2.26 2.26 0 0 0 1.617-.686 2.37 2.37 0 0 0 .67-1.655v-11.28a2.4 2.4 0 0 0-.278-1.122 2.3 2.3 0 0 0-.77-.846l-8.552-5.628c-.37-.243-.8-.372-1.238-.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.839 22.732h-6.67a.82.82 0 0 1-.59-.25.864.864 0 0 1 0-1.207.82.82 0 0 1 .59-.25h6.67c.22 0 .433.09.59.25a.864.864 0 0 1 0 1.207.82.82 0 0 1-.59.25"
  })));
};
export default SvgHome;